/**
 * Whether two numbers are roughly equal up to a certain precision.
 *
 * @param numA
 * @param numB
 * @param precision
 */
export function areNumbersRoughlyEqual(numA, numB, precision = 3) {
    return numA.toFixed(precision) === numB.toFixed(precision);
}
/**
 * Round a number to the given number of `decimalPlaces`.
 *
 * @param num
 * @param decimalPlaces
 */
export function round(num, decimalPlaces = 2) {
    return Number(num.toFixed(decimalPlaces));
}
/**
 * Clamp a given `value` between a minimum and maximum value.
 *
 * @param min
 * @param value
 * @param max
 */
export function clampNumber(min, value, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * Get the number of decimal places in the given `num`.
 *
 * @param num
 * @example `1` -> `0`
 * @example `1.0` -> `0`
 * @example `1.1` -> `1`
 * @example `1.12` -> `2`
 */
export function getNumberOfDecimalPlaces(num) {
    var _a, _b;
    return (_b = (_a = String(num).split('.')[1]) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
}
